import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1c4aad50"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "E808BRenderContainer"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " ", -1));
const _hoisted_3 = {
  class: "ft20"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "下列图中，各边与对角的颜色是否相同？", -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "1. 全同（3同），中间圆圈是红色——选\"1\"，中间圆圈不是红色——选\"01\"", -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "2. 一同，中间圆圈是绿色——选\"2\"，中间圆圈不是绿色——选\"02\"", -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "3. 全不同（0同），中间圆圈是蓝色——选\"3\"，中间圆圈不是蓝色——选\"03\"", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_row = _resolveComponent("el-row");
  const _component_CirclePlusInTriangle = _resolveComponent("CirclePlusInTriangle");
  const _component_DoubleChoiceBtnGroup = _resolveComponent("DoubleChoiceBtnGroup");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_row, {
    class: "flex items-center justify-center"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 8,
      class: "flex items-center justify-center"
    }, {
      default: _withCtx(() => [_hoisted_2]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 8,
      class: "flex items-center justify-center"
    }, {
      default: _withCtx(() => [_createElementVNode("span", _hoisted_3, "第" + _toDisplayString((($props.data[$props.data.length - 1].questionIndex + 1) / 12).toFixed(0)) + "组", 1)]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 8,
      class: "flex justify-end items-center"
    }, {
      default: _withCtx(() => [$props.reviewMode ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        style: {
          "background": "#1388ff",
          "color": "white"
        },
        class: "ptr opd6 brd4",
        onClick: _cache[0] || (_cache[0] = $event => _ctx.$router.go(-1))
      }, "结束回看")) : _createCommentVNode("", true)]),
      _: 1
    })]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "flex flex-col mt16"
  }, {
    default: _withCtx(() => [_hoisted_4, _hoisted_5, _hoisted_6, _hoisted_7]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "flex items-center justify-center"
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.data, q => {
      return _openBlock(), _createBlock(_component_el_col, {
        span: 4,
        class: "mt32 flex flex-col flex items-center justify-center",
        key: q.questionIndex
      }, {
        default: _withCtx(() => [_createVNode(_component_CirclePlusInTriangle, {
          colors: q.question
        }, null, 8, ["colors"]), (_openBlock(), _createBlock(_component_DoubleChoiceBtnGroup, {
          review: $props.review && $props.review[q.questionIndex] ? $props.review[q.questionIndex].answer : null,
          key: `btn_${q.questionIndex}_${q.question}`,
          onAnswer: a => $options.onSelectAnswer(q.questionIndex, a)
        }, null, 8, ["review", "onAnswer"])), $props.review ? (_openBlock(), _createBlock(_component_el_row, {
          key: 0,
          class: "flex flex-col mt8 ft14"
        }, {
          default: _withCtx(() => [_createElementVNode("span", null, "正确答案:" + _toDisplayString(q.rightAnswer), 1), $props.review[q.questionIndex] ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            style: _normalizeStyle({
              color: $props.review[q.questionIndex].result ? 'green' : 'red'
            })
          }, "您的答案:" + _toDisplayString($props.review[q.questionIndex].answer), 5)) : _createCommentVNode("", true)]),
          _: 2
        }, 1024)) : _createCommentVNode("", true)]),
        _: 2
      }, 1024);
    }), 128))]),
    _: 1
  })]);
}